export const GUI_STATE_UPDATE_TOAST = 'GUI_STATE_UPDATE_TOAST';
//# sourceMappingURL=types.js.map